import Vue from 'vue';

const state = {
  genres: {
    options: [],
    selectedGenre: null,
  },
};

const getters = {
  'get-genre-options': (state, getters, rootState) => {
    return state.genres.options;
  },
  'get-selected-genre': (state, getters, rootState) => {
    return state.genres.selectedGenre;
  },
};

const actions = {
  setAvailableGenres({ commit }, genres) {
    commit('saveAvailableGenres', genres);
  },

  setSelectedGenre({ commit }, genres) {
    commit('saveSelectedGenre', genres);
  },
};

const mutations = {
  saveAvailableGenres(state, genres) {
    Vue.set(state.genres, 'options', genres);
  },

  saveSelectedGenre(state, genre) {
    Vue.set(state.genres, 'selectedGenre', genre);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
